import { useEffect } from 'react';
import { envVars } from '@crehana/constants/env-vars';
export var useInitSentry = function useInitSentry(_ref) {
  var sentryInstance = _ref.sentryInstance;
  useEffect(function () {
    initSentry({
      sentryInstance: sentryInstance
    });
    // this must only run once
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
var initSentry = function initSentry(_ref2) {
  var sentryInstance = _ref2.sentryInstance;
  if (envVars.APP_ENV_IS_PRODUCTION &&
  // this variable will only be set and true in production
  envVars.CREH_SENTRY_ENABLED && typeof window !== 'undefined') {
    sentryInstance.init({
      dsn: envVars.SENTRY_DSN,
      integrations: [sentryInstance.browserTracingIntegration(), sentryInstance.replayIntegration()],
      release: envVars.APP_VERSION,
      debug: false,
      // Tracing
      tracesSampleRate: 1.0,
      //  Capture 100% of the transactions
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ['https://qa.creha.co/api/', 'https://crehana.com/api/'],
      // Session Replay
      replaysSessionSampleRate: 0.01,
      replaysOnErrorSampleRate: 0.1,
      // ignore errors
      denyUrls: [
      // Facebook flakiness
      /graph\.facebook\.com/i,
      // Facebook blocked
      /connect\.facebook\.net\/en_US\/all\.js/i,
      // Woopra flakiness
      /eatdifferent\.com\.woopra-ns\.com/i, /static\.woopra\.com\/js\/woopra\.js/i,
      // Chrome extensions
      /extensions\//i, /^chrome:\/\//i,
      // Other plugins
      /127\.0\.0\.1:4001\/isrunning/i,
      // Cacaoweb
      /webappstoolbarba\.texthelp\.com\//i, /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
      // custom crehana urls
      'https://fast.wistia.com/', 'https://saltcdn2.googleapis.com', 'https://player.vimeo.com/video', 'https://cdn.mxpnl.com', 'https://cdn.datagran.io', 'https://static.hotjar.com', 'https://vars.hotjar.com', 'https://vc.hotjar.io'],
      ignoreErrors: [
      // Error initializing google auth in some environments
      'idpiframe_initialization_failed', /^Object Not Found Matching Id$/,
      // default config
      /.*ChunkLoadError.*/, /.*Invariant Violation.*/, /.*Network error.*/,
      // Handled player errors
      /.*fullscreen.*/, /.*InvalidStateError.*/,
      // Random plugins/extensions
      'top.GLOBALS',
      // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
      'originalCreateNotification', 'canvas.contentDocument', 'MyApp_RemoveAllHighlights', 'http://tt.epicplay.com', "Can't find variable: ZiteReader", 'jigsaw is not defined', 'ComboSearch is not defined', 'http://loading.retry.widdit.com/', 'atomicFindClose',
      // Facebook borked
      'fb_xd_fragment',
      // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
      // reduce this. (thanks @acdha)
      // See http://stackoverflow.com/questions/4113268
      'bmi_SafeAddOnload', 'EBCallBackMessageReceived',
      // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
      'conduitPage',
      // others
      'TypeError: NetworkError when attempting to fetch resource.', 'TypeError: NetworkError when attempting to fetch resource.', 'Event: Non-Error promise rejection captured with keys: currentTarget, isTrusted, target, type', 'NetworkError', 'UnhandledRejection: Non-Error promise rejection captured with value:', 'TypeError: cancelado', "SyntaxError: Unexpected token ';'", "Error: SecurityError: Failed to execute 'sendBeacon' on 'Navigator': sendBeacon() with a Blob whose type is not any of the CORS-safelisted values for the Content-Type request header is disabled temporarily. See http://crbug.com/490015 for details.", 'TypeError: Illegal invocation', 'SyntaxError: Use of const in strict mode.', '[Network Error]: TypeError: Failed to fetch', 'Error: Network error: Failed to fetch', 'Error: [object Object]',
      // Error initializing google auth in some environments
      'idpiframe_initialization_failed', 'UnhandledRejection: Non-Error promise rejection captured with value:', /Can't find variable: al_onPoststitialDismiss/, /Can't find variable: al_onAdViewRendered/, 'Failed to fetch', 'Loading chunk', 'ChunkLoadError'],
      beforeSend: function beforeSend(event, hint) {
        var error = hint && hint.originalException;
        if (error && error instanceof Error && error.message && error.message.match(/Can't find variable: al_onPoststitialDismiss/)) {
          return null;
        }
        return event;
      }
    });
  }
};